import { useState } from 'react';

import { useHostname } from '@/contexts';


import { useNavigate } from 'react-router-dom';
import { Skeleton } from '@/components/Skeleton';

import i18n from '@/i18n';
import { useSearchParams } from 'react-router-dom';
import { Avatar, Typography } from '@mui/joy';
import { Grid, IconButton, Menu, MenuButton, MenuItem } from '@mui/joy';
import { Container } from '@mui/joy';
import { Eye, MusicNote, Pencil, Smiley, Trash } from '@phosphor-icons/react';
import { ArtistCard } from '@/components/ArtistCard';
import { Link } from 'react-router-dom';
import { Case, Do, Empty, ForEach, SwitchCase } from '@/components/Syntax';
import { Table } from '@mui/joy';
import { Dropdown } from '@mui/joy';
import { MoreHoriz } from '@mui/icons-material';
import { useLocalStorage, useManager, useResource } from '@/hooks';
import { EmptyView } from '@/components/EmptyView';
import { GenericList } from '@/components/GenericList';

export function ArtistsPage() {
  const manager = useManager()
 
  return (
    <Container>
      <GenericList
        path={`/artists`}
        sortByFields={[
          {
            id: 'name',
            name: i18n.t('alphabetically')
          },
          {
            id: '-released',
            name: i18n.t('recent-to-oldest-released')
          }
        ]}
        showDefaultColumns={false}
        columns={[
          {
            id: 'image_url',
            name: i18n.t('image'),
            type: 'image',
            sm: true
          },
          {
            id: 'name',
            name: i18n.t('name'),
            type: 'name',
            sm: true,
            render: ({ node, column }) => <Link to={`/${manager?.type}/${manager?.slug}/artist/${node.id}`}>{node[column.id]}</Link>
          }
        ]}
        canDelete={false}
        canEdit={true}
        canView={true}
        Icon={Smiley}
        addLabel={i18n.t('add-artists')}
        filterPlaceholder={i18n.t('filter-artists')}
        NodeCardComponent={ArtistCard}
        heading={i18n.t('artists')}
        addUrl={`../artist/add`}
        baseUrl={`../artist`}
      />
    </Container>
  )
}

export function ArtistsSkeleton({
  q
}) {
  return (
    <Container>
      <div style={{ display: 'flex', flexDirection: 'row', gap: 10}}>
        <Skeleton style={{ width: '100pt', height: '100pt', aspectRatio: '1/1' }} />
        <Skeleton style={{ width: '100pt', height: '100pt', aspectRatio: '1/1' }} />
        <Skeleton style={{ width: '100pt', height: '100pt', aspectRatio: '1/1' }} />
        <Skeleton style={{ width: '100pt', height: '100pt', aspectRatio: '1/1' }} />
      </div>
    </Container>
  )
}

export function ArtistsView({
  q = '',
  viewType
}) {
  const hostname = useHostname()
  const navigate = useNavigate()
  // @ts-ignore
  const { data: artists, refetch: reload } = useResource({
    queryKey: ['artists'],
    path: `/artists`,
    query: {
      q
    }
  })

  function deleteArtist(artistId) {

  }

  return (
    <Container>
      <SwitchCase value={viewType}>
        <Case match="grid">
          <Grid container spacing={2}>
            <ForEach collection={artists}>
              <Do>
                {artist => (
                  <Grid key={artist.id} md={3}> 
                    <ArtistCard component={Link} to={`/dashboard/artist/${artist.id}`} {...artist} />
                  </Grid>
                )}
              </Do>
              <Empty>
                <EmptyView
                  Icon={MusicNote}
                  sx={{ width: '100%'}}
                >
                  {i18n.t('no-artists-found')}
                </EmptyView>
              </Empty>
            </ForEach>
          </Grid>
        </Case>
        <Case match="list">
          <Table>
            <thead>
              <tr>
                <th>
                  
                </th>
                <th>
                  {i18n.t('name')}
                </th>
                <th>
                  {i18n.t('of-releases')}
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <ForEach collection={artists}>
                <Do>
                  {artist => (
                    <tr key={artist.id}>
                      <td width={10}>   
                        <Avatar src={artist.imageUrl} style={{ aspectRatio: '1/1', height: '32pt'}} />
                      </td>
                      <td>
                        <Typography>{artist.name || <i>**No name**</i>}</Typography>
                      </td>
                      <td>
                        <Typography>{artist.numberOfReleases?.toLocaleString(undefined, { maximumFractionDigits: 0, minimumFractionDigits: 0 })}</Typography>
                      </td>
                      <td style={{ textAlign: 'right'}}>
                        <Dropdown>
                          <MenuButton
                          sx={{ opacity: 0.5 }}
                            slots={{ root: IconButton }}
                            slotProps={{ root: { color: 'neutral' } }}
                          >
                            <MoreHoriz />
                          </MenuButton>
                          <Menu placement="bottom-end">
                            <MenuItem onClick={() => navigate(`/dashboard/artist/${artist.id}`)}>  
                              <Eye />{i18n.t('view')}
                            </MenuItem>
                            <MenuItem onClick={() => navigate(`/dashboard/artist/${artist.id}/edit`)}>  
                              <Pencil />{i18n.t('edit')}
                            </MenuItem>
                            <MenuItem sx={{ color: "danger" }} onClick={() => deleteArtist(artist.id)}>  
                              <Trash />{i18n.t('delete')}
                            </MenuItem> 
                          </Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  )}
                </Do>
                <Empty>
                  <tr>
                    <td colSpan={4} style={{ padding: 0 }}>
                      <Empty>
                        <EmptyView
                          Icon={MusicNote}
                          sx={{ width: '100%'}}
                        >
                          {i18n.t('no-artists-found')}
                        </EmptyView>
                      </Empty>
                    </td>
                  </tr>
                </Empty>
              </ForEach>
            </tbody>
          </Table>
        </Case>
      </SwitchCase>
    </Container>
  )
}

export default ArtistsPage